module.exports = __webpack_public_path__ + "img/proj_vis.c381c01d.gif";